import { Row, Col, Container, Button } from 'reactstrap'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import LogoSvg from '../../assets/icons/LogoSvg'
import './Header.css'
import { IconChevronLeft, IconX } from '@tabler/icons-react'

const Header = ({ backButton = true, onClick }) => {
  const navigate = useNavigate()
  return (
    <Container>
      <Row style={{ minWidth: '100%', minHeight: '1.75rem' }} />
      <Row
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
        }}
      >
        {backButton ? (
          <Col>
            <Button
              onClick={onClick}
              style={{
                display: 'flex',
                justifyContent: 'center',
                border: 'none',
                backgroundColor: '#fff',
              }}
            >
              <IconChevronLeft
                style={{
                  backgroundColor: '#EFEFEF',
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                  borderRadius: '50px',
                  padding: '0.1rem',
                  height: '2rem',
                  width: '2rem',
                }}
                color={'#285843'}
                size={20}
              />
            </Button>
          </Col>
        ) : (
          <Col>
            <div style={{ width: '100%' }}></div>
          </Col>
        )}
        <Col
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '1rem',
          }}
        >
          <Button
            className='logo'
            onClick={(e) => {
              e.stopPropagation()
              navigate('/')
            }}
            style={{ backgroundColor: 'inherit', borderStyle: 'none' }}
          >
            <LogoSvg width={'7rem'} />
          </Button>
        </Col>
        <Col className='d-flex justify-content-end' style={{ position: 'relative' }}>
          <Button
            onClick={onClick}
            style={{
              display: 'flex',
              justifyContent: 'center',
              border: 'none',
              backgroundColor: '#fff',
              position: 'absolute',
              top: -25,
              right: 20,
            }}
          >
            <IconX
              style={{
                backgroundColor: '#EFEFEF',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                borderRadius: '50px',
                padding: '0.2rem',
                height: '2rem',
                width: '2rem',
              }}
              color={'#285843'}
              size={20}
            />
          </Button>
        </Col>
      </Row>
    </Container>
  )
}

Header.propTypes = {
  backButton: PropTypes.bool,
}

export default Header
